import { render, staticRenderFns } from "./TTimpexIcon.vue?vue&type=template&id=4b38e45b&scoped=true&"
import script from "./TTimpexIcon.vue?vue&type=script&lang=js&"
export * from "./TTimpexIcon.vue?vue&type=script&lang=js&"
import style0 from "./TTimpexIcon.vue?vue&type=style&index=0&id=4b38e45b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b38e45b",
  null
  
)

/* custom blocks */
import block0 from "./TTimpexIcon.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports